export default "__VITE_ASSET__b9bd9e42__"